import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class GameInitializedAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.eventManager.emit('General.Game.INITIALIZED');
        this.emitter.emit('General.Game.INITIALIZED');
    }

    getName(): string {
        return 'GameInitializedAct';
    }
}